





























import Vue from 'vue';
import { Data as HeadlinesData, DataWithHref } from '@root/modules/headlines/types/headlines';
import ArticleHeadline from './ArticleHeadline.vue';
import UniversalHeadlinesService from '@root/modules/headlines/services/UniversalHeadlines.service';
import getHeadlineWithHref from '@root/modules/headlines/utils/getHeadlineWithHref';
import getArticleUrl from '@root/modules/article/utils/buildArticleUrl';

interface Props {
  category: number;
}

interface Methods {
  addClickData: (headline: HeadlinesData, params: Record<string, any>) => Record<string, any>;
  getHeadline: (headline: HeadlinesData) => DataWithHref;
  getCategoryHeadlines: () => void;
  getArticleHeadlines: () => Promise<HeadlinesData[]>;
}

interface Data {
  domains: string | string[];
  locale: string;
  language: string;
  categoryHeadlines: HeadlinesData[];
  categoryHeadlinesLimit: number;
}

export default Vue.extend<Data, Methods, unknown, Props>({
  components: {
    ArticleHeadline,
  },
  props: {
    category: {
      type: Number,
      required: true,
    },
  },
  data() {
    const { domain, locale, temporaryAllowedDomains, lang } = this.$channelConfig('settings');
    const domains = temporaryAllowedDomains ? [...new Set([...temporaryAllowedDomains, domain])] : domain;
    return {
      domains,
      locale,
      language: lang.toUpperCase(),
      categoryHeadlines: [],
      categoryHeadlinesLimit: 5,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getCategoryHeadlines();
    });
  },
  methods: {
    addClickData(headline: HeadlinesData, params: Record<string, any>) {
      const clickData: Record<string, any> = {};

      clickData.articleLayout = 'a';
      clickData.listType = params.listType;
      clickData.listPosition = params.listPosition;
      clickData.listArticleId = headline.id;
      clickData.listArticleUrl = getArticleUrl({ article: headline, domain: headline.primaryCategory.channel.url });
      clickData.listArticlePosition = params.listIndex;

      return { ...headline, clickData };
    },
    getHeadline(headline) {
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
      return getHeadlineWithHref({ headline, domain: this.domains, fakeDomainEnabled });
    },
    async getCategoryHeadlines() {
      this.categoryHeadlines = await this.getArticleHeadlines();
    },
    async getArticleHeadlines() {
      const universalHeadlinesService = new UniversalHeadlinesService();
      const headlines = await universalHeadlinesService.fetch({ categoryId: this.category, limit: this.categoryHeadlinesLimit });
      return headlines.items;
    },
  },
});
